import React from 'react';
import Popover from 'react-bootstrap/Popover';

const FilterPopover = ({
    t,
    activeFilterTab,
    setActiveFilterTab,
    filterSearchText,
    setFilterSearchText,
    availableSkills,
    availableTextTypes,
    availableDimComps,
    availableElements,
    selectedSkillNames,
    selectedTextTypeNames,
    selectedDimCompNames,
    selectedElementNames,
    toggleFilterItem,
    clearAllFilters,
    totalSelectedFilters
}) => {
    return (
        <Popover 
            id="popover-filter-curriculum" 
            style={{ 
                direction: 'rtl', 
                textAlign: 'right', 
                width: '92vw', 
                maxWidth: '420px', 
                borderRadius: '16px', 
                border: '1px solid rgba(146, 39, 143, 0.15)', 
                boxShadow: '0 15px 35px rgba(0,0,0,0.12), 0 5px 15px rgba(146, 39, 143, 0.08)', 
                overflow: 'hidden' 
            }}
        >
            <Popover.Title 
                as="h3" 
                className="font-weight-bold d-flex align-items-center justify-content-between py-3 px-3" 
                style={{ 
                    background: 'linear-gradient(135deg, #fcfaff 0%, #f4ebf8 100%)', 
                    borderBottom: '1px solid rgba(146, 39, 143, 0.1)', 
                    color: '#4a154b' 
                }}
            >
                <span className="d-flex align-items-center" style={{ fontSize: '14px' }}>
                    <span 
                        className="d-inline-flex align-items-center justify-content-center mr-2 ml-2" 
                        style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: 'rgba(146, 39, 143, 0.12)', color: '#92278f' }}
                    >
                        <i className="fad fa-sliders-h" style={{ fontSize: '13px' }}></i>
                    </span>
                    {t("FilterByCurriculum") || "تصفية المعايير والمهارات"}
                </span>
                {totalSelectedFilters > 0 && (
                    <button 
                        type="button" 
                        onClick={clearAllFilters} 
                        className="btn btn-sm btn-link text-danger p-0 m-0 font-weight-bold" 
                        style={{ fontSize: '11px', textDecoration: 'none' }}
                    >
                        <i className="fas fa-trash-alt ml-1"></i>
                        {t("ClearFilter") || "إلغاء التصفية"}
                    </button>
                )}
            </Popover.Title>
            <Popover.Content style={{ padding: '14px', backgroundColor: '#ffffff' }}>
                {/* Horizontal Category Navigation Tabs Bar */}
                <div 
                    className="d-flex align-items-center flex-nowrap mb-3 pb-2 border-bottom" 
                    style={{ 
                        gap: '6px', 
                        overflowX: 'auto', 
                        whiteSpace: 'nowrap',
                        scrollbarWidth: 'thin',
                        WebkitOverflowScrolling: 'touch'
                    }}
                >
                    {availableSkills.length > 0 && (
                        <button 
                            type="button" 
                            onClick={() => setActiveFilterTab(activeFilterTab === 'skill' ? 'all' : 'skill')}
                            className="btn btn-sm flex-shrink-0 d-inline-flex align-items-center"
                            style={{ 
                                width: 'auto',
                                fontSize: '11px', 
                                padding: '5px 12px', 
                                borderRadius: '20px', 
                                fontWeight: '600',
                                background: activeFilterTab === 'skill' ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' : '#f1f5f9',
                                color: activeFilterTab === 'skill' ? '#ffffff' : '#64748b',
                                border: 'none',
                                boxShadow: activeFilterTab === 'skill' ? '0 3px 8px rgba(245, 158, 11, 0.35)' : 'none',
                                transition: 'all 0.2s ease',
                                gap: '4px'
                            }}
                        >
                            <i className="fad fa-lightbulb ml-1"></i> {t("Skills") || "المهارات"}
                            <span className="badge badge-pill ml-1" style={{ backgroundColor: activeFilterTab === 'skill' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.06)', color: 'inherit' }}>
                                {availableSkills.length}
                            </span>
                        </button>
                    )}

                    {availableTextTypes.length > 0 && (
                        <button 
                            type="button" 
                            onClick={() => setActiveFilterTab(activeFilterTab === 'textType' ? 'all' : 'textType')}
                            className="btn btn-sm flex-shrink-0 d-inline-flex align-items-center"
                            style={{ 
                                width: 'auto',
                                fontSize: '11px', 
                                padding: '5px 12px', 
                                borderRadius: '20px', 
                                fontWeight: '600',
                                background: activeFilterTab === 'textType' ? 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' : '#f1f5f9',
                                color: activeFilterTab === 'textType' ? '#ffffff' : '#64748b',
                                border: 'none',
                                boxShadow: activeFilterTab === 'textType' ? '0 3px 8px rgba(14, 165, 233, 0.35)' : 'none',
                                transition: 'all 0.2s ease',
                                gap: '4px'
                            }}
                        >
                            <i className="fad fa-file-alt ml-1"></i> {t("TextTypes") || "أنواع النصوص"}
                            <span className="badge badge-pill ml-1" style={{ backgroundColor: activeFilterTab === 'textType' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.06)', color: 'inherit' }}>
                                {availableTextTypes.length}
                            </span>
                        </button>
                    )}

                    {availableDimComps.length > 0 && (
                        <button 
                            type="button" 
                            onClick={() => setActiveFilterTab(activeFilterTab === 'dimComp' ? 'all' : 'dimComp')}
                            className="btn btn-sm flex-shrink-0 d-inline-flex align-items-center"
                            style={{ 
                                width: 'auto',
                                fontSize: '11px', 
                                padding: '5px 12px', 
                                borderRadius: '20px', 
                                fontWeight: '600',
                                background: activeFilterTab === 'dimComp' ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' : '#f1f5f9',
                                color: activeFilterTab === 'dimComp' ? '#ffffff' : '#64748b',
                                border: 'none',
                                boxShadow: activeFilterTab === 'dimComp' ? '0 3px 8px rgba(16, 185, 129, 0.35)' : 'none',
                                transition: 'all 0.2s ease',
                                gap: '4px'
                            }}
                        >
                            <i className="fad fa-layer-group ml-1"></i> {t("DimensionComponents") || "مكونات الأبعاد"}
                            <span className="badge badge-pill ml-1" style={{ backgroundColor: activeFilterTab === 'dimComp' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.06)', color: 'inherit' }}>
                                {availableDimComps.length}
                            </span>
                        </button>
                    )}

                    {availableElements.length > 0 && (
                        <button 
                            type="button" 
                            onClick={() => setActiveFilterTab(activeFilterTab === 'element' ? 'all' : 'element')}
                            className="btn btn-sm flex-shrink-0 d-inline-flex align-items-center"
                            style={{ 
                                width: 'auto',
                                fontSize: '11px', 
                                padding: '5px 12px', 
                                borderRadius: '20px', 
                                fontWeight: '600',
                                background: activeFilterTab === 'element' ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' : '#f1f5f9',
                                color: activeFilterTab === 'element' ? '#ffffff' : '#64748b',
                                border: 'none',
                                boxShadow: activeFilterTab === 'element' ? '0 3px 8px rgba(239, 68, 68, 0.35)' : 'none',
                                transition: 'all 0.2s ease',
                                gap: '4px'
                            }}
                        >
                            <i className="fad fa-cube ml-1"></i> {t("Elements") || "العناصر"}
                            <span className="badge badge-pill ml-1" style={{ backgroundColor: activeFilterTab === 'element' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.06)', color: 'inherit' }}>
                                {availableElements.length}
                            </span>
                        </button>
                    )}
                </div>

                {/* Quick Search inside Popover (Under Tabs) */}
                <div className="mb-3 position-relative">
                    <input 
                        type="text" 
                        className="form-control form-control-sm pr-4 pl-3" 
                        placeholder={
                            activeFilterTab === 'skill' ? (t("SearchInSkills") || "ابحث في المهارات...") :
                            activeFilterTab === 'textType' ? (t("SearchInTextTypes") || "ابحث في أنواع النصوص...") :
                            activeFilterTab === 'dimComp' ? (t("SearchInDimensionComponents") || "ابحث في مكونات الأبعاد...") :
                            activeFilterTab === 'element' ? (t("SearchInElements") || "ابحث في العناصر...") :
                            (t("SearchFilterPlaceholder") || "ابحث في القائمة...")
                        }
                        value={filterSearchText || ''}
                        onChange={e => setFilterSearchText(e.target.value)}
                        style={{ fontSize: '12px', borderRadius: '20px', border: '1px solid #e2e8f0', backgroundColor: '#f8fafc', height: '34px', boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.03)' }}
                    />
                    <i className="fas fa-search position-absolute text-muted" style={{ left: '12px', top: '10px', fontSize: '12px' }}></i>
                </div>

                <div style={{ maxHeight: '250px', overflowY: 'auto', paddingRight: '4px', WebkitOverflowScrolling: 'touch' }}>
                    {/* Group 1: Skills */}
                    {(activeFilterTab === 'all' || activeFilterTab === 'skill') && availableSkills.filter(s => !(filterSearchText || '').trim() || s.toLowerCase().includes((filterSearchText || '').trim().toLowerCase())).length > 0 && (
                        <div className="mb-3">
                            <div className="font-weight-bold mb-2 pb-1 border-bottom small" style={{ color: '#d97706', borderColor: 'rgba(245, 158, 11, 0.2)' }}>
                                <span className="d-flex align-items-center">
                                    <i className="fad fa-lightbulb text-warning ml-1"></i>
                                    {t("Skills") || "المهارات"}
                                </span>
                            </div>
                            {availableSkills.filter(s => !(filterSearchText || '').trim() || s.toLowerCase().includes((filterSearchText || '').trim().toLowerCase())).map(name => {
                                const isSelected = selectedSkillNames?.includes(name);
                                return (
                                    <div 
                                        key={`skill-${name}`} 
                                        onClick={() => toggleFilterItem('skill', name)}
                                        className="d-flex align-items-center py-2 px-2 text-dark small my-1"
                                        style={{ 
                                            cursor: 'pointer', 
                                            borderRadius: '8px', 
                                            backgroundColor: isSelected ? 'rgba(245, 158, 11, 0.1)' : '#f8fafc',
                                            borderRight: isSelected ? '3px solid #d97706' : '3px solid transparent',
                                            transition: 'all 0.15s ease'
                                        }}
                                    >
                                        <i className={isSelected ? "fas fa-check-circle text-warning ml-2" : "far fa-circle text-muted ml-2"} style={{ fontSize: '14px' }}></i>
                                        <span className="flex-grow-1" style={{ fontWeight: isSelected ? '600' : 'normal', color: isSelected ? '#78350f' : '#334155' }}>{name}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Group 2: Text Types */}
                    {(activeFilterTab === 'all' || activeFilterTab === 'textType') && availableTextTypes.filter(s => !(filterSearchText || '').trim() || s.toLowerCase().includes((filterSearchText || '').trim().toLowerCase())).length > 0 && (
                        <div className="mb-3">
                            <div className="font-weight-bold mb-2 pb-1 border-bottom small" style={{ color: '#0284c7', borderColor: 'rgba(14, 165, 233, 0.2)' }}>
                                <span className="d-flex align-items-center">
                                    <i className="fad fa-file-alt text-info ml-1"></i>
                                    {t("TextTypes") || "أنواع النصوص"}
                                </span>
                            </div>
                            {availableTextTypes.filter(s => !(filterSearchText || '').trim() || s.toLowerCase().includes((filterSearchText || '').trim().toLowerCase())).map(name => {
                                const isSelected = selectedTextTypeNames?.includes(name);
                                return (
                                    <div 
                                        key={`textType-${name}`} 
                                        onClick={() => toggleFilterItem('textType', name)}
                                        className="d-flex align-items-center py-2 px-2 text-dark small my-1"
                                        style={{ 
                                            cursor: 'pointer', 
                                            borderRadius: '8px', 
                                            backgroundColor: isSelected ? 'rgba(14, 165, 233, 0.1)' : '#f8fafc',
                                            borderRight: isSelected ? '3px solid #0284c7' : '3px solid transparent',
                                            transition: 'all 0.15s ease'
                                        }}
                                    >
                                        <i className={isSelected ? "fas fa-check-circle text-info ml-2" : "far fa-circle text-muted ml-2"} style={{ fontSize: '14px' }}></i>
                                        <span className="flex-grow-1" style={{ fontWeight: isSelected ? '600' : 'normal', color: isSelected ? '#0369a1' : '#334155' }}>{name}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Group 3: Dimension Components */}
                    {(activeFilterTab === 'all' || activeFilterTab === 'dimComp') && availableDimComps.filter(s => !(filterSearchText || '').trim() || s.toLowerCase().includes((filterSearchText || '').trim().toLowerCase())).length > 0 && (
                        <div className="mb-3">
                            <div className="font-weight-bold mb-2 pb-1 border-bottom small" style={{ color: '#059669', borderColor: 'rgba(16, 185, 129, 0.2)' }}>
                                <span className="d-flex align-items-center">
                                    <i className="fad fa-layer-group text-success ml-1"></i>
                                    {t("DimensionComponents") || "مكونات الأبعاد"}
                                </span>
                            </div>
                            {availableDimComps.filter(s => !(filterSearchText || '').trim() || s.toLowerCase().includes((filterSearchText || '').trim().toLowerCase())).map(name => {
                                const isSelected = selectedDimCompNames?.includes(name);
                                return (
                                    <div 
                                        key={`dimComp-${name}`} 
                                        onClick={() => toggleFilterItem('dimComp', name)}
                                        className="d-flex align-items-center py-2 px-2 text-dark small my-1"
                                        style={{ 
                                            cursor: 'pointer', 
                                            borderRadius: '8px', 
                                            backgroundColor: isSelected ? 'rgba(16, 185, 129, 0.1)' : '#f8fafc',
                                            borderRight: isSelected ? '3px solid #059669' : '3px solid transparent',
                                            transition: 'all 0.15s ease'
                                        }}
                                    >
                                        <i className={isSelected ? "fas fa-check-circle text-success ml-2" : "far fa-circle text-muted ml-2"} style={{ fontSize: '14px' }}></i>
                                        <span className="flex-grow-1" style={{ fontWeight: isSelected ? '600' : 'normal', color: isSelected ? '#065f46' : '#334155' }}>{name}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Group 4: Elements */}
                    {(activeFilterTab === 'all' || activeFilterTab === 'element') && availableElements.filter(s => !(filterSearchText || '').trim() || s.toLowerCase().includes((filterSearchText || '').trim().toLowerCase())).length > 0 && (
                        <div className="mb-1">
                            <div className="font-weight-bold mb-2 pb-1 border-bottom small" style={{ color: '#dc2626', borderColor: 'rgba(239, 68, 68, 0.2)' }}>
                                <span className="d-flex align-items-center">
                                    <i className="fad fa-cube text-danger ml-1"></i>
                                    {t("Elements") || "العناصر"}
                                </span>
                            </div>
                            {availableElements.filter(s => !(filterSearchText || '').trim() || s.toLowerCase().includes((filterSearchText || '').trim().toLowerCase())).map(name => {
                                const isSelected = selectedElementNames?.includes(name);
                                return (
                                    <div 
                                        key={`element-${name}`} 
                                        onClick={() => toggleFilterItem('element', name)}
                                        className="d-flex align-items-center py-2 px-2 text-dark small my-1"
                                        style={{ 
                                            cursor: 'pointer', 
                                            borderRadius: '8px', 
                                            backgroundColor: isSelected ? 'rgba(239, 68, 68, 0.1)' : '#f8fafc',
                                            borderRight: isSelected ? '3px solid #dc2626' : '3px solid transparent',
                                            transition: 'all 0.15s ease'
                                        }}
                                    >
                                        <i className={isSelected ? "fas fa-check-circle text-danger ml-2" : "far fa-circle text-muted ml-2"} style={{ fontSize: '14px' }}></i>
                                        <span className="flex-grow-1" style={{ fontWeight: isSelected ? '600' : 'normal', color: isSelected ? '#991b1b' : '#334155' }}>{name}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </Popover.Content>
        </Popover>
    );
};

export default FilterPopover;
